module.exports = __webpack_public_path__ + "img/_icon_send.adb9fe40.svg";